import { z } from "zod";

const configKNXSchema = z.object({
	protocol: z.literal("KNX_S").or(z.literal("KNX_LTE")).or(z.literal("KNX")),
	individualAddress: z.string(),
	internalAddress: z.string()
});

const configBacnetIpSchema = z.object({
	protocol: z.literal("BACNET_IP"),
	networkNumber: z.number().or(z.null()),
	udpPort: z.number(),
	deviceInstance: z.number(),
	physicalConnector: z.union([z.literal("eth1"), z.literal("eth2")])
});

const configWMBusSchema = z.object({
	protocol: z.literal("WMBUS"),
	mode: z.string().or(z.null()),
	physicalConnector: z.string()
});

const configModbusSerial = z.object({
	protocol: z.literal("MODBUS_SERIAL"),
	mode: z.string().or(z.null()),
	physicalConnector: z.string()
});

const configLonIP852Schema = z.object({
	protocol: z.literal("LON_IP852"),
	physicalConnector: z.string(),
	port: z.number(),
	domain: z.number().or(z.null()),
	subnet: z.number().or(z.null()),
	node: z.number().or(z.null())
});

const configLpbSchema = z.object({
	protocol: z.literal("LPB"),
	segmentNumber: z.number(),
	deviceNumber: z.number(),
	timeout: z.number().or(z.null())
});

const configLorawanSchema = z.object({
	protocol: z.literal("LORAWAN_V1_0"),
	regionConfig: z.object({
		name: z.string(),
		frequencyPlanId: z.string()
	})
});

const withoutConfigSchema = z.object({
	protocol: z
		.literal("MODBUS_IP")
		.or(z.literal("LON_FT10"))
		.or(z.literal("MBUS"))
});

const configSchema = configModbusSerial
	.or(configWMBusSchema)
	.or(configKNXSchema)
	.or(configBacnetIpSchema)
	.or(configLonIP852Schema)
	.or(configLpbSchema)
	.or(configLorawanSchema)
	.or(withoutConfigSchema);

export const inputNetworkSchema = z.object({
	name: z.string(),
	description: z.string().or(z.null()).optional(),
	equipments: z.array(z.string()).optional(),
	config: configSchema,
	tags: z.record(z.string(), z.string()),
	retryNumber: z.number(),
	responseTimeout: z.number(),
	interFrameDelay: z.number()
});

export type InputNetwork = z.infer<typeof inputNetworkSchema>;

export const networkSchema = inputNetworkSchema.extend({
	networkId: z.string()
});
